import React, { useState } from 'react';
import { SearchIcon } from 'lucide-react';
import { EmailAuditEntry } from './EmailConfiguration';
interface EmailAuditLogProps {
  auditEntries: EmailAuditEntry[];
  locale: string;
}
export function EmailAuditLog({
  auditEntries,
  locale
}: EmailAuditLogProps) {
  const [searchTerm, setSearchTerm] = useState('');
  const filteredEntries = auditEntries.filter(entry => entry.emailAddress.toLowerCase().includes(searchTerm.toLowerCase()) || entry.subject.toLowerCase().includes(searchTerm.toLowerCase()) || entry.message.toLowerCase().includes(searchTerm.toLowerCase()) || entry.entityName && entry.entityName.toLowerCase().includes(searchTerm.toLowerCase()) || entry.siteName && entry.siteName.toLowerCase().includes(searchTerm.toLowerCase()));
  return <div className="space-y-6" data-id="element-17334">
      <div className="bg-white shadow-sm rounded-lg p-4" data-id="element-17335">
        <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center space-y-4 sm:space-y-0" data-id="element-17336">
          <div className="flex-1 max-w-md" data-id="element-17337">
            <div className="relative rounded-md shadow-sm" data-id="element-17338">
              <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none" data-id="element-17339">
                <SearchIcon className="h-5 w-5 text-gray-400" data-id="element-17340" />
              </div>
              <input type="text" value={searchTerm} onChange={e => setSearchTerm(e.target.value)} className="focus:ring-indigo-500 focus:border-indigo-500 block w-full pl-10 sm:text-sm border-gray-300 rounded-md" placeholder="Search audit log..." data-id="element-17341" />
            </div>
          </div>
        </div>
      </div>
      <div className="bg-white shadow overflow-hidden sm:rounded-lg" data-id="element-17342">
        <table className="min-w-full divide-y divide-gray-200" data-id="element-17343">
          <thead className="bg-gray-50" data-id="element-17344">
            <tr data-id="element-17345">
              <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-17346">
                Timestamp
              </th>
              <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-17347">
                Direction
              </th>
              <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-17348">
                Email
              </th>
              <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-17349">
                Subject
              </th>
              <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-17350">
                Status
              </th>
            </tr>
          </thead>
          <tbody className="bg-white divide-y divide-gray-200" data-id="element-17351">
            {filteredEntries.map(entry => <tr key={entry.id} className="hover:bg-gray-50" data-id="element-17352">
                <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500" data-id="element-17353">
                  {new Date(entry.timestamp).toLocaleString(locale)}
                </td>
                <td className="px-6 py-4 whitespace-nowrap" data-id="element-17354">
                  <span className={`px-2 inline-flex text-xs leading-5 font-semibold rounded-full ${entry.direction === 'Inbound' ? 'bg-green-100 text-green-800' : 'bg-blue-100 text-blue-800'}`} data-id="element-17355">
                    {entry.direction}
                  </span>
                </td>
                <td className="px-6 py-4 whitespace-nowrap" data-id="element-17356">
                  <div className="text-sm text-gray-900" data-id="element-17357">
                    {entry.emailAddress}
                  </div>
                  {entry.entityName && <div className="text-sm text-gray-500" data-id="element-17358">
                      {entry.entityName}
                      {entry.siteName && ` - ${entry.siteName}`}
                    </div>}
                </td>
                <td className="px-6 py-4 whitespace-nowrap" data-id="element-17359">
                  <div className="text-sm text-gray-900" data-id="element-17360">{entry.subject}</div>
                  <div className="text-sm text-gray-500" data-id="element-17361">{entry.message}</div>
                  {entry.attachmentsCount && <div className="text-xs text-gray-400" data-id="element-17362">
                      {entry.attachmentsCount} attachment(s)
                    </div>}
                </td>
                <td className="px-6 py-4 whitespace-nowrap" data-id="element-17363">
                  <span className={`px-2 inline-flex text-xs leading-5 font-semibold rounded-full ${entry.eventType === 'Success' ? 'bg-green-100 text-green-800' : entry.eventType === 'Error' ? 'bg-red-100 text-red-800' : entry.eventType === 'Warning' ? 'bg-yellow-100 text-yellow-800' : 'bg-gray-100 text-gray-800'}`} data-id="element-17364">
                    {entry.eventType}
                  </span>
                </td>
              </tr>)}
          </tbody>
        </table>
      </div>
    </div>;
}